import {
  action,
  observable,
  makeObservable,
  runInAction,
  computed,
} from "mobx";
import api from "../../../api";
// import { CheckboxValueType } from "antd/es/checkbox/Group";
import { DatePickerProps, Modal, message } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import CommonStore from "../common_store";

class PowerManageStore {
  @observable isEnable: string = "";
  @observable accountNo: string = "";
  @observable plainOptions = [];
  @observable defaultCheckedList = [];
  //获取关联用户组列表
  @observable getRelationList: any = {};
  //搜索表单字段
  @observable searchForm: powerSearchData = { isEnable: true };
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getPowerPage();
    },
  };

  @observable getRelationListAll: any = [];
  // @observable checkedList: CheckboxValueType[] = [];
  @observable checkedList: string[] = [];
  //点击编辑框传值
  @observable lookPower: any = {};
  //当前登录账户管理的用户组列表
  @observable manageAccountList: any = {};
  @observable manageAccountReadList: any = {};
  //编辑框控制字段
  @observable addOrUpdateModal: IModal = {
    add: false,
    update: false,
    updateModalType: (type: "add" | "update") => {},
    get isOpen(): boolean {
      return this.add || this.update;
    },
    open: (type: "add" | "update", data: any) => {
      if (type === "add") {
        runInAction(() => {
          this.lookPower = {};
          this.addOrUpdateModal.add = true;
          this.addOrUpdateModal.update = false;
        });
      } else if (type === "update") {
        runInAction(() => {
          this.addOrUpdateModal.add = false;
          this.addOrUpdateModal.update = true;
          this.lookPower = { ...data };
        });
      }
    },
    close: () => {
      runInAction(() => {
        this.addOrUpdateModal.add = false;
        this.addOrUpdateModal.update = false;
        this.lookPower = {};
      });
    },
  };
  @observable modalLoading: boolean = false;

  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  @action
  getPowerPage() {
    if (this.searchForm.expiredTime) {
      this.searchForm.endTime = this.searchForm.expiredTime[1].format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.searchForm.startTime = this.searchForm.expiredTime[0].format(
        "YYYY-MM-DD HH:mm:ss"
      );
    }
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.userAccountApi
      .getPowerPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          res.data.records.forEach((item: any) => {
            //添加用户关联组的值
            item.userAccountGroup = item.groupList
              .map((list: any) => list.label)
              .join(",");
          });
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });

          this.commonStore.getPagePermission("user_account");
          this.getManageAccountList();
          this.getManageAccountReadList();
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  @action
  deleteUserAccount(accountNo: string) {
    api.userAccountApi
      .deleteUserAccount(accountNo)
      .then((res: any) => {
        message.success("删除成功");
        this.resetPage();
        this.getPowerPage();
      })
      .catch((e: any) => {});
  }

  deletePower(accountNo: string) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认删除",
        content: "您确定要删除该账户吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.deleteUserAccount(accountNo);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  setLookPower(obj: any) {
    runInAction(() => {
      this.lookPower = obj;
    });
  }

  @action
  editUserAccount(data: any) {
    api.userAccountApi
      .editUserAccount({
        accountNo: data.no,
        displayName: data.displayName,
        expiredTime: data.expiredTime,
      })
      .then((res: any) => {
        message.success("编辑成功");
        this.getPowerPage();
      })
      .catch((e: any) => {});
  }

  @action
  async getManageAccountList() {
    api.userAccountApi
      .getManageAccountList()
      .then((res: any) => {
        runInAction(() => {
          this.manageAccountList = res.data;
        });
      })
      .catch((e: any) => {});
  }
  @action
  async getManageAccountReadList() {
    api.userAccountApi
      .getManageAccountReadList()
      .then((res: any) => {
        runInAction(() => {
          this.manageAccountReadList = res.data;
        });
      })
      .catch((e: any) => {});
  }

  handleChange(value: any, option: any) {
    console.log(value, option);
  }

  @action
  inviteUserAccount(data: any) {
    api.userAccountApi
      .inviteUserAccount({
        displayName: data.displayName,
        groupNoList: data.groupList,
        expiredTime: data.expiredTime1,
        phoneNumber: data.phoneNumber,
      })
      .then((res: any) => {
        this.resetPage();
        this.getPowerPage();
        message.success("邀请成功");
      })
      .catch((e: any) => {
        message.error("邀请失败");
      });
  }

  @action
  getRelationAccountGroup(accountNo: any) {
    runInAction(() => {
      this.modalLoading = true;
    });
    api.userAccountApi
      .getRelationAccountGroup(accountNo)
      .then((res: any) => {
        runInAction(() => {
          this.getRelationList = res.data;
          this.accountNo = accountNo;
          this.modalLoading = false;
        });
        this.getRelationsAll();
      })
      .catch((e: any) => {
        runInAction(() => {
          this.modalLoading = false;
        });
      });
  }

  // onChangeList = (list: CheckboxValueType[]) => {
  onChangeList = (list: string[]) => {
    this.checkedList = list;
  };

  @action
  getRelationsAll() {
    //subjectOwned所有权限设置为已选
    this.getRelationListAll = this.getRelationList.subjectOwned.map(
      (item: any) => {
        item.checked = true;
        return item;
      }
    );
    //subjectOwned拥有，accountOwned未拥有设置禁用
    this.getRelationListAll.forEach((item: any) => {
      if (
        this.getRelationList.accountOwned
          .map((item1: any) => item1.value)
          .indexOf(item.value) === -1
      ) {
        item.disabled = true;
      }
    });
    //subjectOwned没有，accountOwned拥有的设置为可选
    this.getRelationList.accountOwned.forEach((item: any) => {
      if (
        this.getRelationListAll
          .map((item1: any) => item1.value)
          .indexOf(item.value) === -1
      ) {
        this.getRelationListAll.push(item);
      }
    });
    this.plainOptions = this.getRelationListAll.map((item: any) => item.label);
    this.checkedList = this.getRelationListAll
      .filter((item: any) => item.checked)
      .map((item: any) => item.value);
  }

  // @action changeCheckList(list: CheckboxValueType[]) {
  @action changeCheckList(list: string[]) {
    this.plainOptions = this.getRelationListAll.map((item: any) => item.label);
    this.checkedList = [...list];
    this.getRelationListAll.forEach((item: any) => {
      list.indexOf(item.value) > -1
        ? (item.checked = true)
        : delete item.checked;
    });
  }

  @action
  setRelationAccountGroup() {
    api.userAccountApi
      .setRelationAccountGroup({
        accountNo: this.accountNo,
        groupNoList: this.checkedList,
      })
      .then((res: any) => {
        message.success("保存成功");
        this.getPowerPage();
      })
      .catch((e: any) => {});
  }

  @action
  setEnable(accountNo: any, isEnable: any) {
    api.userAccountApi
      .setEnable({ accountNo: accountNo, isEnable: !isEnable })
      .then((res: any) => {
        message.success(isEnable ? "禁用成功" : "启用成功");
        this.getPowerPage();
      })
      .catch((e: any) => {});
  }
  @action changeIsEnable(isEnable: any, accountNo: any) {
    this.isEnable = isEnable
      ? "您确定要禁用该账户吗？"
      : "您确定要启用该账户吗？";
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认启用/禁用",
        content: this.isEnable,
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.setEnable(accountNo, isEnable);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }
}

export default PowerManageStore;
